import CustomerHome from './CustomerHome';

export default CustomerHome;
